import { Model } from "pinia-orm";
import { SessionsGroup, CertipersUser } from "@/models";

export default class UserSessionsGroup extends Model {
  static entity = "userSessionsGroups";
  static primaryKey = "uuid";

  static fields() {
    return {
      uuid: this.uid(""),
      status: this.string(""),
      isDisplayed: this.boolean(true),
      createdAt: this.string(""),
      summonedAt: this.string(""),

      // Foreign keys
      sessionsGroupUuid: this.string(""),
      sessionsGroupData: this.belongsTo(SessionsGroup, "sessionsGroupUuid"),
      userUuid: this.string(""),
      user: this.belongsTo(CertipersUser, "userUuid"),
    };
  }
}
